<template>
    <span v-if="get(eventQualifications, 'qualification')">
        <v-icon v-if="get(eventQualifications, 'qualified')" v-bind="$attrs" color="green"> check_circle </v-icon>
        <v-icon
            v-else-if="get(eventQualifications, 'competed') && !get(eventQualifications, 'qualified')"
            v-bind="$attrs"
            color="red"
        >
            cancel
        </v-icon>
    </span>

    <span v-else-if="showNa" v-html="showNa === true ? 'N/A' : showNa" />
</template>

<script>
import get from 'lodash/get.js';

export default {
    name: 'QualificationCheck',

    props: {
        qualifier: {
            type: Object,
            required: true,
        },

        event: {
            type: String,
            required: true,
        },

        showNa: {
            type: [Boolean, String],
            default: false,
        },
    },

    computed: {
        eventQualifications() {
            return get(this.qualifier, `qualifications.${this.event}`);
        },
    },

    methods: {
        get,
    },
};
</script>
